module.exports = __webpack_public_path__ + "img/CM-JN-24-Chevy-Lifestyle.528ac28c.jpg";